import {Callout} from '@wandb/weave/components/Callout';
import {IconName} from '@wandb/weave/components/Icon';
import {TagColorName} from '@wandb/weave/components/Tag';
import {kebabCase} from 'lodash';
import React from 'react';
import {twMerge} from 'tailwind-merge';

type WorkspaceModeOptionProps = {
  color: TagColorName;
  description: string;
  icon: IconName;
  isSelected: boolean;
  label: string;
  onClick: () => void;
};

export const WorkspaceModeOption = ({
  color,
  description,
  icon,
  isSelected,
  label,
  onClick,
}: WorkspaceModeOptionProps) => {
  const labelId = `${kebabCase(label)}-label`;
  return (
    <div
      role="radio"
      aria-checked={isSelected}
      aria-labelledby={labelId}
      className={twMerge(
        'w-[320px] cursor-pointer rounded-lg border border-moon-250 bg-white p-32 text-center hover:shadow-flat',
        isSelected
          ? 'border-teal-450 outline outline-1 outline-teal-450'
          : 'hover:border-moon-300'
      )}
      onClick={onClick}>
      <Callout
        className="mx-auto mb-16"
        size="small"
        color={color}
        icon={icon}
      />
      <p id={labelId} className="mb-8 block text-lg font-semibold">
        {label}
      </p>
      <span className="text-sm text-moon-600">{description}</span>
    </div>
  );
};
